import { Modal } from 'components';
import { Button } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  open: boolean;
  apply: () => void;
  cancel: () => void;
  description?: string;
}

const SaveConfirm: React.FC<Props> = ({
  open,
  apply,
  cancel,
  description = 'Sivulla on tallentamattomia muutoksia. Haluatko tallentaa muutokset?',
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      maxWidth="xs"
      fullWidth
      withCloseButton={false}
      hideBackdrop
    >
      <div>
        <p className={classes.title}>Huom!</p>
        <p className={classes.description}>{description}</p>
        <div className={classes.flex}>
          <Button
            classes={{
              root: clsx(classes.button, classes.notSave),
            }}
            onClick={cancel}
          >
            ÄLÄ TALLENNA
          </Button>
          <Button
            classes={{
              root: clsx(classes.button, classes.save),
            }}
            onClick={apply}
          >
            TALLENNA
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SaveConfirm;
